'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _SchedulingQueue2 = require('../core/SchedulingQueue');

var _SchedulingQueue3 = _interopRequireDefault(_SchedulingQueue2);

var _TimeEngine4 = require('../core/TimeEngine');

var _TimeEngine5 = _interopRequireDefault(_TimeEngine4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EPSILON = 1e-8;

var LoopControl = function (_TimeEngine) {
  (0, _inherits3.default)(LoopControl, _TimeEngine);

  function LoopControl(playControl) {
    (0, _classCallCheck3.default)(this, LoopControl);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LoopControl.__proto__ || (0, _getPrototypeOf2.default)(LoopControl)).call(this));

    _this.__playControl = playControl;
    _this.speed = 1;
    _this.lower = -Infinity;
    _this.upper = Infinity;
    return _this;
  }

  // TimeEngine method (scheduled interface)


  (0, _createClass3.default)(LoopControl, [{
    key: 'advanceTime',
    value: function advanceTime(time) {
      var playControl = this.__playControl;
      var speed = this.speed;
      var lower = this.lower;
      var upper = this.upper;

      if (speed > 0) time += EPSILON;else time -= EPSILON;

      if (speed > 0) {
        playControl.syncSpeed(time, lower, speed, true);
        return playControl.__getTimeAtPosition(upper) - EPSILON;
      } else if (speed < 0) {
        playControl.syncSpeed(time, upper, speed, true);
        return playControl.__getTimeAtPosition(lower) + EPSILON;
      }

      return Infinity;
    }
  }, {
    key: 'reschedule',
    value: function reschedule(speed) {
      var playControl = this.__playControl;
      var lower = Math.min(playControl.__loopStart, playControl.__loopEnd);
      var upper = Math.max(playControl.__loopStart, playControl.__loopEnd);

      this.speed = speed;
      this.lower = lower;
      this.upper = upper;

      if (lower === upper) speed = 0;

      if (speed > 0) this.resetTime(playControl.__getTimeAtPosition(upper) - EPSILON);else if (speed < 0) this.resetTime(playControl.__getTimeAtPosition(lower) + EPSILON);else this.resetTime(Infinity);
    }
  }, {
    key: 'applyLoopBoundaries',
    value: function applyLoopBoundaries(position, speed) {
      var lower = this.lower;
      var upper = this.upper;

      if (speed > 0 && position >= upper) return lower + (position - lower) % (upper - lower);else if (speed < 0 && position < lower) return upper - (upper - position) % (upper - lower);

      return position;
    }
  }]);
  return LoopControl;
}(_TimeEngine5.default);

// play controlled base class


var PlayControlled = function () {
  function PlayControlled(playControl, engine) {
    (0, _classCallCheck3.default)(this, PlayControlled);

    this.__playControl = playControl;

    engine.master = this;
    this.__engine = engine;
  }

  (0, _createClass3.default)(PlayControlled, [{
    key: 'syncSpeed',
    value: function syncSpeed(time, position, speed, seek, lastSpeed) {
      this.__engine.syncSpeed(time, position, speed, seek);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.__playControl = null;

      this.__engine.master = null;
      this.__engine = null;
    }
  }, {
    key: 'currentTime',
    get: function get() {
      return this.__playControl.currentTime;
    }
  }, {
    key: 'audioTime',
    get: function get() {
      return this.__playControl.audioTime;
    }
  }, {
    key: 'currentPosition',
    get: function get() {
      return this.__playControl.currentPosition;
    }
  }]);
  return PlayControlled;
}();

// play control for engines implementing the *speed-controlled* interface


var PlayControlledSpeedControlled = function (_PlayControlled) {
  (0, _inherits3.default)(PlayControlledSpeedControlled, _PlayControlled);

  function PlayControlledSpeedControlled(playControl, engine) {
    (0, _classCallCheck3.default)(this, PlayControlledSpeedControlled);
    return (0, _possibleConstructorReturn3.default)(this, (PlayControlledSpeedControlled.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledSpeedControlled)).call(this, playControl, engine));
  }

  return PlayControlledSpeedControlled;
}(PlayControlled);

// play control for engines implmenting the *transported* interface


var PlayControlledTransported = function (_PlayControlled2) {
  (0, _inherits3.default)(PlayControlledTransported, _PlayControlled2);

  function PlayControlledTransported(playControl, engine) {
    (0, _classCallCheck3.default)(this, PlayControlledTransported);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (PlayControlledTransported.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledTransported)).call(this, playControl, engine));

    _this3.__schedulerHook = new PlayControlledSchedulerHook(playControl, engine);
    return _this3;
  }

  (0, _createClass3.default)(PlayControlledTransported, [{
    key: 'syncSpeed',
    value: function syncSpeed(time, position, speed, seek, lastSpeed) {
      if (speed !== lastSpeed || seek) {
        var nextPosition;

        // resync transported engines
        if (seek || speed * lastSpeed < 0) {
          // seek or reverse direction
          nextPosition = this.__engine.syncPosition(time, position, speed);
        } else if (lastSpeed === 0) {
          // start
          nextPosition = this.__engine.syncPosition(time, position, speed);
        } else if (speed === 0) {
          // stop / pause
          this.__engine.syncPosition(time, position, speed);
          nextPosition = Infinity;

          // if (this.__engine.syncSpeed)
          //   this.__engine.syncSpeed(time, position, 0);
        } else if (this.__engine.syncSpeed) {
          // change speed without reversing direction
          this.__engine.syncSpeed(time, position, speed);
        }

        this.__schedulerHook.resetPosition(nextPosition);
      }
    }
  }, {
    key: 'resetEnginePosition',
    value: function resetEnginePosition(engine) {
      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (position === undefined) {
        var playControl = this.__playControl;
        var time = playControl.__sync();

        position = this.__engine.syncPosition(time, playControl.__position, playControl.__speed);
      }

      this.__schedulerHook.resetPosition(position);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.__schedulerHook.destroy();
      this.__schedulerHook = null;

      (0, _get3.default)(PlayControlledTransported.prototype.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledTransported.prototype), 'destroy', this).call(this);
    }
  }]);
  return PlayControlledTransported;
}(PlayControlled);

// play control for time engines implementing the *scheduled* interface


var PlayControlledScheduled = function (_PlayControlled3) {
  (0, _inherits3.default)(PlayControlledScheduled, _PlayControlled3);

  function PlayControlledScheduled(playControl, engine) {
    (0, _classCallCheck3.default)(this, PlayControlledScheduled);

    // scheduling queue becomes master of engine
    var _this4 = (0, _possibleConstructorReturn3.default)(this, (PlayControlledScheduled.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledScheduled)).call(this, playControl, engine));

    engine.master = null;
    _this4.__schedulingQueue = new PlayControlledSchedulingQueue(playControl, engine);
    return _this4;
  }

  (0, _createClass3.default)(PlayControlledScheduled, [{
    key: 'syncSpeed',
    value: function syncSpeed(time, position, speed, seek, lastSpeed) {
      if (lastSpeed === 0 && speed !== 0) // start or seek
        this.__engine.resetTime();else if (lastSpeed !== 0 && speed === 0) // stop
        this.__engine.resetTime(Infinity);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.__schedulingQueue.destroy();
      (0, _get3.default)(PlayControlledScheduled.prototype.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledScheduled.prototype), 'destroy', this).call(this);
    }
  }]);
  return PlayControlledScheduled;
}(PlayControlled);

// translates transported engine advancePosition into global scheduler times


var PlayControlledSchedulerHook = function (_TimeEngine2) {
  (0, _inherits3.default)(PlayControlledSchedulerHook, _TimeEngine2);

  function PlayControlledSchedulerHook(playControl, engine) {
    (0, _classCallCheck3.default)(this, PlayControlledSchedulerHook);

    var _this5 = (0, _possibleConstructorReturn3.default)(this, (PlayControlledSchedulerHook.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledSchedulerHook)).call(this));

    _this5.__playControl = playControl;
    _this5.__engine = engine;

    _this5.__nextPosition = Infinity;
    playControl.__scheduler.add(_this5, Infinity);
    return _this5;
  }

  (0, _createClass3.default)(PlayControlledSchedulerHook, [{
    key: 'advanceTime',
    value: function advanceTime(time) {
      var playControl = this.__playControl;
      var engine = this.__engine;
      var position = this.__nextPosition;
      var nextPosition = engine.advancePosition(time, position, playControl.__speed);
      var nextTime = playControl.__getTimeAtPosition(nextPosition);

      this.__nextPosition = nextPosition;
      return nextTime;
    }
  }, {
    key: 'resetPosition',
    value: function resetPosition() {
      var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.__nextPosition;

      var time = this.__playControl.__getTimeAtPosition(position);
      this.__nextPosition = position;
      this.resetTime(time);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this.__playControl.__scheduler.remove(this);
      this.__playControl = null;
      this.__engine = null;
    }
  }, {
    key: 'currentTime',
    get: function get() {
      return this.__playControl.currentTime;
    }
  }, {
    key: 'audioTime',
    get: function get() {
      return this.__playControl.audioTime;
    }
  }, {
    key: 'currentPosition',
    get: function get() {
      return this.__playControl.currentPosition;
    }
  }]);
  return PlayControlledSchedulerHook;
}(_TimeEngine5.default);

// internal scheduling queue that returns the current position (and time) of the play control


var PlayControlledSchedulingQueue = function (_SchedulingQueue) {
  (0, _inherits3.default)(PlayControlledSchedulingQueue, _SchedulingQueue);

  function PlayControlledSchedulingQueue(playControl, engine) {
    (0, _classCallCheck3.default)(this, PlayControlledSchedulingQueue);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (PlayControlledSchedulingQueue.__proto__ || (0, _getPrototypeOf2.default)(PlayControlledSchedulingQueue)).call(this));

    _this6.__playControl = playControl;
    _this6.__engine = engine;

    _this6.add(engine, Infinity);
    playControl.__scheduler.add(_this6, Infinity);
    return _this6;
  }

  (0, _createClass3.default)(PlayControlledSchedulingQueue, [{
    key: 'destroy',
    value: function destroy() {
      this.__playControl.__scheduler.remove(this);
      this.remove(this.__engine);

      this.__playControl = null;
      this.__engine = null;
    }
  }, {
    key: 'currentTime',
    get: function get() {
      return this.__playControl.currentTime;
    }
  }, {
    key: 'audioTime',
    get: function get() {
      return this.__playControl.audioTime;
    }
  }, {
    key: 'currentPosition',
    get: function get() {
      return this.__playControl.currentPosition;
    }
  }]);
  return PlayControlledSchedulingQueue;
}(_SchedulingQueue3.default);

/**
 * Extends Time Engine to provide playback control of a Time Engine instance.
 *
 * [example]{@link https://rawgit.com/wavesjs/waves-masters/master/examples/transport/index.html}
 *
 * @extends TimeEngine
 * @param {Object} scheduler - instance of Scheduler
 * @param {TimeEngine} engine - engine to control
 *
 * @example
 * import * as masters from 'waves-masters';
 *
 * const getTimeFunction = () => {
 *   const now = process.hrtime();
 *   return now[0] + now[1] * 1e-9;
 * }
 * const scheduler = new masters.Scheduler(getTimeFunction);
 * const playerEngine = new MyTimeEngine();
 * const playControl = new masters.PlayControl(scheduler, playerEngine);
 *
 * playControl.start();
 */


var PlayControl = function (_TimeEngine3) {
  (0, _inherits3.default)(PlayControl, _TimeEngine3);

  function PlayControl(scheduler, engine) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck3.default)(this, PlayControl);

    var _this7 = (0, _possibleConstructorReturn3.default)(this, (PlayControl.__proto__ || (0, _getPrototypeOf2.default)(PlayControl)).call(this));

    _this7.__scheduler = scheduler;

    _this7.__playControlled = null;
    _this7.__loopControl = null;
    _this7.__loopStart = 0;
    _this7.__loopEnd = 1;

    // synchronized tie, position, and speed
    _this7.__time = 0;
    _this7.__position = 0;
    _this7.__speed = 0;

    // non-zero "user" speed
    _this7.__playingSpeed = 1;

    if (engine) _this7.__setEngine(engine);
    return _this7;
  }

  (0, _createClass3.default)(PlayControl, [{
    key: '__setEngine',
    value: function __setEngine(engine) {
      if (engine.master) throw new Error("object has already been added to a master");

      if (_TimeEngine5.default.implementsSpeedControlled(engine)) this.__playControlled = new PlayControlledSpeedControlled(this, engine);else if (_TimeEngine5.default.implementsTransported(engine)) this.__playControlled = new PlayControlledTransported(this, engine);else if (_TimeEngine5.default.implementsScheduled(engine)) this.__playControlled = new PlayControlledScheduled(this, engine);else throw new Error("object cannot be added to play control");
    }
  }, {
    key: '__resetEngine',
    value: function __resetEngine() {
      this.__playControlled.destroy();
      this.__playControlled = null;
    }

    /**
     * Calculate/extrapolate playing time for given position
     *
     * @param {Number} position position
     * @return {Number} extrapolated time
     * @private
     */

  }, {
    key: '__getTimeAtPosition',
    value: function __getTimeAtPosition(position) {
      return this.__time + (position - this.__position) / this.__speed;
    }

    /**
     * Calculate/extrapolate playing position for given time
     *
     * @param {Number} time time
     * @return {Number} extrapolated position
     * @private
     */

  }, {
    key: '__getPositionAtTime',
    value: function __getPositionAtTime(time) {
      return this.__position + (time - this.__time) * this.__speed;
    }
  }, {
    key: '__sync',
    value: function __sync() {
      var now = this.currentTime;
      this.__position += (now - this.__time) * this.__speed;
      this.__time = now;

      return now;
    }

    /**
     * Get current master time.
     *
     * @name currentTime
     * @type {Number}
     * @memberof PlayControl
     * @instance
     * @readonly
     */

  }, {
    key: 'set',
    value: function set() {
      var engine = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var time = this.__sync();
      var speed = this.__speed;

      if (this.__playControlled !== null && this.__playControlled.__engine !== engine) {

        this.syncSpeed(time, this.__position, 0);

        if (this.__playControlled) this.__resetEngine();

        if (this.__playControlled === null && engine !== null) {
          this.__setEngine(engine);

          if (speed !== 0) this.syncSpeed(time, this.__position, speed);
        }
      }
    }

    /**
     * Sets the play control loop behavior.
     *
     * @type {Boolean}
     * @name loop
     * @memberof PlayControl
     * @instance
     */

  }, {
    key: 'setLoopBoundaries',


    /**
     * Sets loop start and end time.
     *
     * @param {Number} loopStart - loop start value.
     * @param {Number} loopEnd - loop end value.
     */
    value: function setLoopBoundaries(loopStart, loopEnd) {
      this.__loopStart = loopStart;
      this.__loopEnd = loopEnd;

      this.loop = this.loop;
    }

    /**
     * Sets loop start value
     *
     * @type {Number}
     * @name loopStart
     * @memberof PlayControl
     * @instance
     */

  }, {
    key: 'syncSpeed',


    // TimeEngine method (speed-controlled interface)
    value: function syncSpeed(time, position, speed) {
      var seek = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var lastSpeed = this.__speed;

      if (speed !== lastSpeed || seek) {
        if ((seek || lastSpeed === 0) && this.__loopControl) position = this.__loopControl.applyLoopBoundaries(position, speed);

        this.__time = time;
        this.__position = position;
        this.__speed = speed;

        if (this.__playControlled) this.__playControlled.syncSpeed(time, position, speed, seek, lastSpeed);

        if (this.__loopControl) this.__loopControl.reschedule(speed);
      }
    }

    /**
     * Starts playback
     */

  }, {
    key: 'start',
    value: function start() {
      var time = this.__sync();
      this.syncSpeed(time, this.__position, this.__playingSpeed);
    }

    /**
     * Pauses playback and stays at the same position.
     */

  }, {
    key: 'pause',
    value: function pause() {
      var time = this.__sync();
      this.syncSpeed(time, this.__position, 0);
    }

    /**
     * Stops playback and seeks to initial (0) position.
     */

  }, {
    key: 'stop',
    value: function stop() {
      var time = this.__sync();
      this.syncSpeed(time, 0, 0, true);
    }

    /**
     * If speed if provided, sets the playback speed. The speed value should
     * be non-zero between -16 and -1/16 or between 1/16 and 16.
     *
     * @type {Number}
     * @name speed
     * @memberof PlayControl
     * @instance
     */

  }, {
    key: 'seek',


    /**
     * Set (jump to) playing position.
     *
     * @param {Number} position target position
     */
    value: function seek(position) {
      var time = this.__sync();
      this.__position = position;
      this.syncSpeed(time, position, this.__speed, true);
    }
  }, {
    key: 'currentTime',
    get: function get() {
      return this.__scheduler.currentTime;
    }

    /**
     * Get current master time.
     *
     * @name audioTime
     * @type {Number}
     * @memberof PlayControl
     * @instance
     * @readonly
     */

  }, {
    key: 'audioTime',
    get: function get() {
      return this.__scheduler.audioTime;
    }

    /**
     * Get current master position.
     * This function will be replaced when the play-control is added to a master.
     *
     * @name currentPosition
     * @type {Number}
     * @memberof PlayControl
     * @instance
     * @readonly
     */

  }, {
    key: 'currentPosition',
    get: function get() {
      return this.__position + (this.__scheduler.currentTime - this.__time) * this.__speed;
    }

    /**
     * Returns if the play control is running.
     *
     * @name running
     * @type {Boolean}
     * @memberof PlayControl
     * @instance
     * @readonly
     */

  }, {
    key: 'running',
    get: function get() {
      return !(this.__speed === 0);
    }
  }, {
    key: 'loop',
    set: function set(enable) {
      if (enable && this.__loopStart > -Infinity && this.__loopEnd < Infinity) {
        if (!this.__loopControl) {
          this.__loopControl = new LoopControl(this);
          this.__scheduler.add(this.__loopControl, Infinity);
        }

        if (this.__speed !== 0) {
          var position = this.currentPosition;
          var lower = Math.min(this.__loopStart, this.__loopEnd);
          var upper = Math.max(this.__loopStart, this.__loopEnd);

          if (this.__speed > 0 && position > upper) this.seek(upper);else if (this.__speed < 0 && position < lower) this.seek(lower);else this.__loopControl.reschedule(this.__speed);
        }
      } else if (this.__loopControl) {
        this.__scheduler.remove(this.__loopControl);
        this.__loopControl = null;
      }
    },
    get: function get() {
      return !!this.__loopControl;
    }
  }, {
    key: 'loopStart',
    set: function set(loopStart) {
      this.setLoopBoundaries(loopStart, this.__loopEnd);
    },
    get: function get() {
      return this.__loopStart;
    }

    /**
     * Sets loop end value
     *
     * @type {Number}
     * @name loopEnd
     * @memberof PlayControl
     * @instance
     */

  }, {
    key: 'loopEnd',
    set: function set(loopEnd) {
      this.setLoopBoundaries(this.__loopStart, loopEnd);
    },
    get: function get() {
      return this.__loopEnd;
    }
  }, {
    key: 'speed',
    set: function set(speed) {
      var time = this.__sync();

      if (speed >= 0) {
        if (speed < 0.01) speed = 0.01;else if (speed > 100) speed = 100;
      } else {
        if (speed < -100) speed = -100;else if (speed > -0.01) speed = -0.01;
      }

      this.__playingSpeed = speed;

      if (!this.master && this.__speed !== 0) this.syncSpeed(time, this.__position, speed);
    },
    get: function get() {
      return this.__playingSpeed;
    }
  }]);
  return PlayControl;
}(_TimeEngine5.default);

exports.default = PlayControl;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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